import bodyCountMapping from "./bodyCountMapping";
import selector from "./selector";
import { log } from "./logger";
export function bodySwap() {
    if (window.maxbody == 3) {
        jQuery("div[bodySwap=building] .building").remove();
    }
    else {
        jQuery("div[bodySwap=bus] .man").remove();
    }
    for (var counter = 0; counter < window.bodycount; counter++) {
        if (window.maxbody == 3) {
            jQuery("div[bodySwap=building]").append(' <i class="fas fa-building building"></i>');
            continue;
        }
        jQuery("div[bodySwap=bus]").append(' <i class="fas fa-male man"></i> ');
    }
    for (var counter = 0; counter < window.maxbody - window.bodycount; counter++) {
        if (window.maxbody == 3) {
            jQuery("div[bodySwap=building]").append(' <i class="fas fa-building building building-dim"></i> ');
            continue;
        }
        jQuery("div[bodySwap=bus]").append(' <i class="fas fa-male man man-dim"></i> ');
    }
}
export async function UpdateBodys() {
}
export function TriggerBodyUpdate(e) {
    if (e.attr("id")?.includes("minus")) {
        e.on("click", () => {
            if (window.bodycount > 1) {
                jQuery(selector.TarifrechnerResult).slideUp();
                jQuery(selector.TarifrechnerFinePrint).slideUp();
                window.bodycount -= 1;
                jQuery(selector.KWH).each((i, el) => {
                    jQuery(el).val(bodyCountMapping(window.bodycount));
                });
                updateBodys();
                //getPrice();
            }
        });
    }
    else {
        e.on("click", () => {
            log("trigger plus");
            if (window.bodycount < window.maxbody) {
                jQuery(selector.TarifrechnerResult).slideUp();
                jQuery(selector.TarifrechnerFinePrint).slideUp();
                window.bodycount += 1;
                jQuery(selector.KWH).each((i, el) => {
                    jQuery(el).val(bodyCountMapping(window.bodycount));
                });
                updateBodys();
            }
        });
    }
}
export function updateBodys() {
    let bus = jQuery(selector.Bodys);
    bus.each((i, el) => {
        let children = jQuery(el).find("svg");
        let bodycount = window.bodycount;
        children.each((i, el) => {
            if (i + 1 <= bodycount) {
                jQuery(el).removeClass("icon-dark");
            }
            else {
                jQuery(el).addClass("icon-dark");
            }
        });
    });
}
